import { GrowthStampReportsReducer } from "../reducer/GrowthStampReportsReducer";

export const reducer = GrowthStampReportsReducer;